export default __webpack_public_path__ + "static/media/img2.7e442f42.jpg";